import { useTranslation } from "react-i18next";
import { ReactComponent as DumpsterIcon } from "../../static/assets/dashboard-dumpster.svg";
import { ReactComponent as PinIcon } from "../../static/assets/dashboard-pin.svg";

export const DashboardClientSummary = ({
  corporationName,
  siteCount,
  zoneCount,
}) => {
  const { t } = useTranslation();

  const siteLabel = t(`dashboard.siteCount${siteCount > 1 ? "_plural" : ""}`, {
    count: siteCount,
  });
  const zoneLabel = t(`dashboard.zoneCount${zoneCount > 1 ? "_plural" : ""}`, {
    count: zoneCount,
  });

  return (
    <article className="dashboard-client-summary">
      <div className="dashboard-client-summary-content">
        <p className="dashboard-client-summary-name">
          {corporationName || "—"}
        </p>
        <div className="dashboard-client-summary-meta">
          <div className="dashboard-client-summary-sites">
            <PinIcon
              className="dashboard-client-summary-pin"
              aria-hidden="true"
            />
            <span>{siteLabel}</span>
          </div>
          <p className="dashboard-client-summary-zones">{zoneLabel}</p>
        </div>
      </div>
      <div className="dashboard-client-summary-logo">
        <DumpsterIcon
          className="dashboard-client-summary-dumpster"
          aria-hidden="true"
        />
      </div>
    </article>
  );
};
